export enum HISTORIAL_TYPES {
    HISTORIAL_SAVE_SEARCH_FORMFILTER = 'HISTORIAL_SAVE_SEARCH_FORMFILTER',
    HISTORIAL_FORMFILTER_CHANGE = 'HISTORIAL_FORMFILTER_CHANGE',
    HISTORIAL_SET_ERRORS_FILTER = 'HISTORIAL_SET_ERRORS_FILTER',
    HISTORIAL_SET_ACTIVE_PAGE = 'HISTORIAL_SET_ACTIVE_PAGE',
    HISTORIAL_SET_TOTALS_PAGES = 'HISTORIAL_SET_TOTALS_PAGES',
    
    HISTORIAL_MODAL_ANULAR_STATUS = 'HISTORIAL_MODALANULAR_STATUS',
    HISTORIAL_MODAL_OPTIONS_STATUS = 'HISTORIAL_MODAL_OPTIONS_STATUS',
    HISTORIAL_MODAL_EMAIL_STATUS = 'HISTORIAL_MODALEMAIL_STATUS',
    HISTORIAL_MODAL_PRINT_STATUS = 'HISTORIAL_MODAL_PRINT_STATUS',
    
    HISTORIAL_ARRAYRESULTADO = 'HISTORIAL_ARRAYRESULTADO',
    HISTORIAL_SET_ITEMS_ANULAR = 'HISTORIAL_SET_ITEMS_ANULAR',
    HISTORIAL_SET_ACTIVE_FACTURA = 'HISTORIAL_SET_ACTIVE_FACTURA',

    HISTORIAL_SET_TIPOS_DOCS = 'HISTORIAL_SET_TIPOS_DOCS',
    HISTORIAL_SET_QR = 'HISTORIAL_SET_QR',
    HISTORIAL_SET_ANULADO = 'HISTORIAL_SET_ANULADO',
    HISTORIAL_SET_RESULT_ANULACIONES = 'HISTORIAL_SET_RESULT_ANULACIONES',
    HISTORIAL_RESET_ALL = 'HISTORIAL_RESET_ALL',
}
  